module.exports = __webpack_public_path__ + "img/shape-square.74dd1051.svg";